
// This is an auto generated file - do not edit!
// Swagger path: /api/Activity/{id}/duedate

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    Activity, ActivityDueDate
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class ActivityIdDuedateApiService extends BaseApiService {
    
    patch(id: string, activity: ActivityDueDate, options = {}): Observable<Activity> {
        return this._patch<Activity, ActivityDueDate>(
            `/Activity/${id}/duedate`,
            new ActivityDueDate(activity),
            options
        );
    }
}
